import { getMemberRateLimits } from './GetMemberRateLimits';

export const OfficeRateLimitsService = {
  getMemberRateLimits,
};
